export default "__VITE_ASSET__403c123e__"